export const LAST_CLAIM_UPDATE = 'LAST_CLAIM-STEP_UPDATE';
export const CLAIMS_STEPS = 'CLAIMS_STEPS';
